export default class HeroImage {
    constructor() {
        console.log('%c👍🏼 Hero Image', 'color: yellow');
        
        this.heroImage = document.querySelector('.hero-image');
    }
    init() {

        let imageScale = 100;
        let titleScale = 1.1;

        if (window.innerWidth > 768 ) {
            imageScale = 66;
            titleScale = 0.76;
        }
        const img = this.heroImage.querySelector('img');
        const title = this.heroImage.querySelector('.hero-image__title');
      
        const handleScroll = () => {
            
            
            const imgRect = img.getBoundingClientRect();
            const titleRect = title.getBoundingClientRect();
            const imageTravelDistance = titleRect.top - imgRect.top;
            const titleTravelDistance = imgRect.height * titleScale;

            img.style.transform = `translateY(` + imageTravelDistance + `px)`;
            img.style.width = imageScale + `%`;
            
            title.style.transform = `translateY(` + titleTravelDistance + `px)`;

            document.removeEventListener("scroll", handleScroll)
        }
        document.addEventListener("scroll", handleScroll);

        window.addEventListener("resize", () => {
            console.log('resizing');
            img.style.transform = null;
            title.style.transform = null;
            img.style.width = null;
            document.addEventListener("scroll", handleScroll);
        })
    }
}